import React, { useState } from "react";
import "./Home.css";
import { useCopiedBanner } from "../../components/useCopiedBanner/useCopiedBanner";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import LinkIcon from "@mui/icons-material/Link";

function Home() {
  const [mailIcon, setMailIcon] = useState(<EmailIcon />);
  const { showBanner, CopiedBanner } = useCopiedBanner();
  const handleCopy = () => {
    navigator.clipboard.writeText("vahangevorgyan0212@email.com");
    showBanner();
  };

  const handleEmailClick = () => {
    setMailIcon(<MarkEmailReadIcon />);
    setTimeout(() => {
      setMailIcon(<EmailIcon />);
    }, 1000);
  };

  const lessSkills = [
    "JavaScript",
    "TypeScript",
    "HTML",
    "CSS",
    "React JS",
    "Next JS",
    "TailwindCSS",
    "Bootstrap",
    "Python",
    "C++",
    "Java",
    "SQL",
    "PHP",
    "C#",
    "Swift",
  ];

  const allSkills = [
    "JavaScript",
    "TypeScript",
    "HTML",
    "CSS",
    "React JS",
    "Next JS",
    "TailwindCSS",
    "Bootstrap",
    "React Native",
    "Three JS",
    "Node JS",
    "Express JS",
    "Socket IO",
    "Firebase",
    "Django",
    "Ohm JS",
    "SQL",
    "PHP",
    "Python",
    "C++",
    "Java",
    "C#",
    "Swift",
    "GDScript",
    "WebGL",
    "OpenGL",
    "Unity",
    "AWS",
    "Git / Github",
    "Gradle",
    "Maven",
    "Xcode",
    "Visual Studio",
    "IntelliJ IDEA",
    "Vercel",
  ];

  const [showAllSkills, setShowAllSkills] = useState(false);

  const toggleSkills = () => {
    setShowAllSkills(!showAllSkills);
  };

  const skills = showAllSkills ? allSkills : lessSkills;

  const icon = showAllSkills ? <RemoveIcon /> : <AddIcon />;

  return (
    <div className="InfoComponent">
      <h1 className="home-intro">
        HI, I AM VAHAN - <p>SOFTWARE ENGINEER 👋</p>
      </h1>
      <div className="home-location-container">
        <LocationOnIcon />
        <p>Los Angeles, CA</p>
      </div>
      <div className="home-moreinfo">
        <p>
          <b>6+ years</b> of experience building applications using
          <b> React, TypeScript, JavaScript,</b> and modern{" "}
          <b>CSS frameworks</b>, with supporting backend experience.
          <br></br>
          <br></br>Additionally, I am focused on creating
          <b> 2D and 3D game engines</b> and have worked on a range of software
          projects.
        </p>
      </div>
      <div className="home-links-container">
        <button
          onClick={() => window.open("https://github.com/vahan-gev", "_blank")}
        >
          <GitHubIcon />
        </button>
        <button
          onClick={() =>
            window.open("https://www.linkedin.com/in/vahangevorgyan/", "_blank")
          }
        >
          <LinkedInIcon />
        </button>
        <button
          onClick={() => {
            handleEmailClick();
            handleCopy();
          }}
        >
          {mailIcon}
        </button>
        <CopiedBanner />
        <button
          className="resume-button"
          onClick={() =>
            window.open(
              "/assets/resume/VahanGevorgyanResume.pdf",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          Resume <LinkIcon />
        </button>
      </div>
      <div className="home-skills-container">
        <ul>
          {skills.map((skill, index) => (
            <li key={index}>{skill}</li>
          ))}
          <button onClick={toggleSkills}>{icon}</button>
        </ul>
      </div>
    </div>
  );
}

export default Home;
